import { render } from "./InfoModal.vue?vue&type=template&id=ce2c5466"
import script from "./InfoModal.vue?vue&type=script&lang=js"
export * from "./InfoModal.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./InfoModal.vue?vue&type=style&index=0&id=ce2c5466&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__